import { all } from 'redux-saga/effects';
import packagesSaga from './packages/saga';
import referralsSaga from './referrals/saga';
import expensesSaga from './expenses/saga';
import customernotificationsSaga from './customernotifications/saga';
//end-of-imports

export default function* rootSaga(getState) {
  yield all([
    packagesSaga(),
     referralsSaga(),
   expensesSaga(),
   customernotificationsSaga(),
  //end-of-sagas
  ]);
}
